import {
  GO_TO_STEP,
  SET_SUGGESTED_LOGIN,
  RESET,
  SET_CODE_SOURCE,
  RESET_SESSION_ID,
  Action,
  ACTIVATE,
  LifeCycleAction,
} from './actions';
import {
  SAVE as SAVE_EMAIL_PHONE_AND_FIRSTNAME,
  Action as PersonalDataAction,
} from './components/PersonalDataForm/actions';
import {
  SAVE as SAVE_LOGIN_AND_PASS,
  Action as LoginAndPassAction,
} from './components/LoginAndPasswordForm/actions';
import { Step, SendingMethod } from './types';

export interface State {
  step: Step;
  sessionId?: string;
  suggestedLogin?: string;
  login: string;
  password: string;
  firstName: string;
  email?: string;
  phone?: string;
  codeSource: SendingMethod;
  smsCodeTimeout: number;
  emailCodeTimeout: number;
}

const initState: State = {
  step: 'PERSONAL_DATA',
  login: '',
  password: '',
  firstName: '',
  codeSource: SendingMethod.PHONE,
  smsCodeTimeout: 0,
  emailCodeTimeout: 0,
};

type AllActions = Action | LifeCycleAction | PersonalDataAction | LoginAndPassAction;

export default function reducer(state: State = initState, action: AllActions): State {
  switch (action.type) {
    case ACTIVATE:
      return {
        ...state,
        step: 'PERSONAL_DATA',
      };

    case RESET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload.sessionId,
      };

    case GO_TO_STEP:
      return {
        ...state,
        step: action.payload.step,
      };

    case SET_SUGGESTED_LOGIN:
      return {
        ...state,
        suggestedLogin: action.payload.login,
      };

    case SAVE_LOGIN_AND_PASS:
      return {
        ...state,
        login: action.payload.login,
        password: action.payload.password,
      };

    case SET_CODE_SOURCE:
      return {
        ...state,
        codeSource: action.payload.source,
        [action.payload.source === SendingMethod.PHONE ? 'smsCodeTimeout' : 'emailCodeTimeout']:
          action.meta.ts + 60000,
      };

    case SAVE_EMAIL_PHONE_AND_FIRSTNAME:
      return {
        ...state,
        firstName: action.payload.firstName,
        email: action.payload.email,
        phone: action.payload.phone,
        smsCodeTimeout: action.meta.ts + 60000,
      };

    case RESET:
      return {
        ...initState,
        firstName: state.firstName,
      };
    default:
      return state;
  }
}
